module.exports = __webpack_public_path__ + "static/media/hair4.f2755355.png";